import React, { useEffect, useState } from 'react';
import {
  Button,
  Divider,
  Dropdown,
  Menu,
  Modal,
  Popconfirm,
  Select,
  Table,
  Tag,
} from 'antd';
import {
  EditOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
  DownloadOutlined,
  DownOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as axios from 'axios';
import CustomContent from '../../../components/Content/CustomContent';
import {
  deleteNewssAction,
  getNewssAction,
} from '../../../actions/AppCms/NewsActions';
import { history } from '../../../utils/history';
import { host } from '../../../utils/config';
import Authorized from '../../../components/Authorization/Authorized';
import {
  resetNewsFilters,
  updateNewsFilters,
} from '../../../actions/FilterActions';
import { getCmsLanguagesAction } from '../../../actions/AppCms/CmsLanguageActions';

const { Option } = Select;

const NewsList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [action, setAction] = useState({});
  const [language, setLanguage] = useState('');

  const { newss, newsFilterParams, cmsLanguageList } = useSelector(store => ({
    newss: store.newsReducer.newss,
    newsFilterParams: store.filterReducer.newsFilterParams,
    cmsLanguageList: store.cmsLanguageReducer.cmsLanguageList,
  }));

  useEffect(() => {
    dispatch(getNewssAction(newsFilterParams));
    dispatch(getCmsLanguagesAction());
  }, []);

  useEffect(() => {
    cmsLanguageList.map(item =>
      item.defaultInMobileApp ? setLanguage(item.isoLanguage.code) : '',
    );
  }, [cmsLanguageList]);

  // const handleSearch = value => {
  //   handleFilterParams({
  //     search: value,
  //     page: 0,
  //   });
  // };

  // const handleFilterParams = filter => {
  //   const newParams = {
  //     ...newsFilterParams,
  //     ...filter,
  //     page: 0,
  //   };
  //   dispatch(updateNewsFilters(newParams));
  //   dispatch(getNewssAction(newParams));
  // };

  const handleDownload = () => {
    const bearer = localStorage.getItem('userToken');


    let options = {
      url: host + '/api/news/export',
      method: 'GET',
      responseType: 'blob', // important
      headers: { Authorization: bearer },
    };
    if (action.key === '1') {
      options = {
        ...options,
        params: {
          all: true,
          language,
        },
      };
    } else if (action.key === '2') {
      options = {
        ...options,
        params: {
          idList: selectedRowKeys.join(','),
          all: false,
          language,
        },
      };
    }
    axios(options).then(response => {

      const today = new Date();
      const currentDate =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'news-reports-' + currentDate + '.csv');
      document.body.appendChild(link);
      link.click();
    });
  };

  const showModal = value => {
    setAction(value);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    handleDownload();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleTableChange = pagination => {


    if (newsFilterParams.size !== pagination.pageSize) {

      const newParams = {
        ...newsFilterParams,
        size: pagination.pageSize,
        page: 0,
      };
      dispatch(updateNewsFilters(newParams));
      dispatch(getNewssAction(newParams));
      return;
    }
    if (newsFilterParams.page !== pagination.current - 1) {

      const newParams = {
        ...newsFilterParams,
        page: pagination.current - 1,
      };
      dispatch(updateNewsFilters(newParams));
      dispatch(getNewssAction(newParams));
    }
  };

  const handleAddNew = () => {
    history.push('/add-news');
  };

  const handleMultipleDelete = () => {
    dispatch(deleteNewssAction(selectedRowKeys.join(','))).then(() => {
      setSelectedRowKeys([]);
    });
  };

  const handleSingleDelete = () => {
    dispatch(deleteNewssAction(selectedItem.id)).then(() => {
      setSelectedRowKeys([]);
    });
  };

  const handleMenuClick = value => {
    if (value.key === 'edit') {
      const updatePath = '/updateNews/' + selectedItem.id;

      history.push(updatePath);
    }
  };

  function handleLanguageChange(value) {
    setLanguage(value);

  }

  const onSelectChange = selected => {

    setSelectedRowKeys(selected);
  };

  const hasSelected = selectedRowKeys.length > 0;
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const menu = (
    <Authorized asset="appcms" operation="write">
      <Menu onClick={handleMenuClick}>
        <Menu.Item key="edit">
          <EditOutlined />
          {t('common.update')}
        </Menu.Item>
        <Menu.Item key="delete">
          <Popconfirm
            title={t('common.sureToDelete')}
            placement="left"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => handleSingleDelete()}
          >
            <DeleteOutlined />
            {t('common.delete')}
          </Popconfirm>
        </Menu.Item>
      </Menu>
    </Authorized>
  );

  const exportMenu = (
    <Menu onClick={showModal}>
      <Menu.Item key="1">
        <DownloadOutlined />
        {t('appCms.news.allNews')}
      </Menu.Item>
      <Menu.Item key="2" disabled={!hasSelected}>
        <DownloadOutlined />
        {t('appCms.news.selectedNews')}
      </Menu.Item>
    </Menu>
  );
  const columns = [
    {
      title: t('common.title'),
      dataIndex: ['data', 'content'],
      key: 'title',
      render: text => <span>{text && text[0].title}</span>,
    },
    {
      title: t('appCms.news.date'),
      dataIndex: ['data', 'date'],
      key: 'date',
      width: '10%',
    },
    {
      title: t('appCms.news.published'),
      dataIndex: ['data', 'published'],
      key: 'published',
      width: '10%',
      render: text => (
        <>
          {text ? (
            <Tag
              style={{
                color: '#28cc40',
                borderColor: '#28cc40',
              }}
            >
              {t('appCms.news.publishedTag')}
            </Tag>
          ) : null}
        </>
      ),
    },
    {
      title: t('common.actions'),
      key: 'action',
      width: '10%',
      render: () => (
        <span>
          <Dropdown overlay={menu} trigger={['click']}>
            <a className="ant-dropdown-link" href="#">
              {t('common.actions')} <DownOutlined />
            </a>
          </Dropdown>
        </span>
      ),
    },
  ];

  return (
    (<CustomContent>
      {/* <Search
          placeholder="Search"
          onSearch={value => handleSearch(value)}
          allowClear
          style={{ float: 'left', width: 300 }}
          defaultValue={newsFilterParams.search}
        />
       */}
      <Authorized asset="appcms" operation="write">
        <Button
          icon={<PlusOutlined />}
          type="primary"
          style={{ float: 'right', marginBottom: 16 }}
          onClick={handleAddNew}
        >
          {t('common.add')}
        </Button>
        <Popconfirm
          title={t('common.sureToDelete')}
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          onConfirm={() => handleMultipleDelete()}
        >
          <Button
            icon={<DeleteOutlined />}
            disabled={!hasSelected}
            style={{ float: 'right', marginBottom: 16, marginRight: 16 }}
          >
            {t('common.delete')}
          </Button>
        </Popconfirm>
      </Authorized>
      <Dropdown overlay={exportMenu}>
        <Button
          icon={<DownloadOutlined />}
          style={{ float: 'right', marginBottom: 16, marginRight: 16 }}
        >
          {t('appCms.export')}
        </Button>
      </Dropdown>
      <Divider />
      <Table
        columns={columns}
        dataSource={newss.content}
        rowSelection={rowSelection}
        pagination={{
          defaultPageSize: newsFilterParams.size,
          current: newsFilterParams.page + 1,
          total: newss.totalElements,
          showTotal: (total, range) => {
            return t('common.paginationTotal', { start: range[0], end: range[1], total });
          },
          showSizeChanger: true,
          pageSizeOptions: [
            '10',
            '20',
            '30',
            '40',
            '50',
            '100',
            '200',
            '500',
            '1000',
          ],
        }}
        onChange={handleTableChange}
        rowKey={record => record.id}
        onRow={record => {
          return {
            onClick: () => setSelectedItem(record),
          };
        }}
      />
      <Modal
        title={t('appCms.news.language')}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>{t('appCms.news.selectExportLanguage')}</p>
        <Select
          defaultValue={language}
          style={{ width: 220 }}
          onChange={handleLanguageChange}
        >
          {cmsLanguageList.map(item => (
            <Option key={item.id} value={item.isoLanguage.code}>
              {item.isoLanguage.title}
            </Option>
          ))}
        </Select>
      </Modal>
      {/* <WrappedNewsListDrawer
          visible={drawerVisible}
          parentOnClose={this.onCloseDrawer}
          handleFilterParams={this.handleFilterParams}
          filterParams={newsFilterParams}
          handleResetFilters={this.handleResetFilters}
        /> */}
    </CustomContent>)
  );
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  getNewssAction,
  deleteNewssAction,
  resetNewsFilters,
  updateNewsFilters,
})(NewsList);
